import React, { useEffect, useState } from "react";
import { Col, DatePicker } from "antd";
import moment from "moment";
import { ExamTimeWay } from "service/exam";
import style from "./index.module.scss";

interface DateRangePickerProps {
    examTimeWay: ExamTimeWay; //考试时间类型
    start: string; //开始时间
    end: string; //结束时间
    onChange: (value: [string, string]) => void;
}

export default function DateRangePickerFree(props: DateRangePickerProps) {
    const { RangePicker } = DatePicker;
    const format = "YYYY-MM-DD HH:mm:ss";
    const { start, end, onChange } = props;

    const [startTime, setStartTime] = useState(start ? start : "");
    const [endTime, setEndTime] = useState(end ? end : "");

    function disabledDate(current: moment.Moment | null): boolean {
        if (!current) return false;
        return current < moment().startOf("day");
    }

    useEffect(() => {
        onChange([startTime, endTime]);
    }, [startTime, endTime]);

    //实验时间改变
    function onProjectTimeChange(dates: any) {
        const start =
            dates.length !== 0 ? moment(dates?.[0]).format(format) : "";
        const end = dates.length !== 0 ? moment(dates?.[1]).format(format) : "";
        setStartTime(start);
        setEndTime(end);
    }

    return (
        <div className={style.root}>
            <Col span={13}>
                <RangePicker
                    disabledDate={disabledDate}
                    value={
                        !startTime
                            ? [null, null]
                            : [
                                  moment(startTime, format),
                                  moment(endTime, format)
                              ]
                    }
                    showTime={{
                        hideDisabledOptions: true
                    }}
                    format="YYYY-MM-DD HH:mm:ss"
                    onChange={onProjectTimeChange}
                />
            </Col>
        </div>
    );
}
